webpackJsonp([246501157640856],{

/***/ 605:
/***/ (function(module, exports) {

	module.exports = [{"id":"2017-12-14","meetupLink":"https://www.meetup.com/Real-World-React/events/245095649","name":"Visual Regression Testing, React + Serverless, Component Best Practices","place":"Brigade","address":"524 3rd St · San Francisco, CA","date":"Thursday, December 14, 2017","time":"6:00 PM to 9:00 PM","mapLat":37.7808637,"mapLng":-122.3954939,"mapZoom":18,"talks":["Valeri Karpov: Casting and Validating State With Archetype","Parris Khachi: The Holy Grail of Visual Regression Testing","David Wells: React + Serverless Backends: A match made in heaven","Vlad Tsvang and Ryan Booth: Reusability Without Compromise"]}]

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

	module.exports = {"googleAPIKey":"AIzaSyBuvyYfJWem38uw9s92xIP3muV5q3OIra8"}

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactJss = __webpack_require__(6);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dots = __webpack_require__(22);
	
	var _dots2 = _interopRequireDefault(_dots);
	
	var _settings = __webpack_require__(608);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _events = __webpack_require__(605);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _components = __webpack_require__(17);
	
	var _containers = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      minHeight: '100vh',
	      flexDirection: 'column'
	    },
	
	    // MAIN
	    main: {
	      flex: '1',
	      '& h1': {
	        marginTop: 0
	      }
	    },
	    mainContainer: {
	      padding: [20, 0]
	    },
	    mainRow: {},
	    mainColumn: {},
	
	    // HEADING
	    heading: {
	      display: 'flex'
	    },
	    headingTitle: {
	      margin: 'auto'
	    },
	    headingTitleClassName: {},
	
	    // EVENTS
	    events: {
	      marginTop: 40
	    },
	    event: {},
	    eventSeparator: {
	      display: 'block',
	      width: '100%',
	      height: 40
	    },
	
	    // FOOTER
	    footer: {
	      backgroundColor: theme.palette.inverted.base,
	      backgroundImage: 'url(' + _dots2.default + ')',
	      position: 'relative',
	      marginTop: 40
	    },
	    footerDrops: {
	      display: 'none'
	    },
	
	    // small -
	    '@media screen and (max-width: 48em)': {
	      // MAIN
	      mainRow: {
	        margin: 0
	      },
	      mainColumn: {
	        padding: 0
	      },
	
	      // HEADING
	      headingTitleClassName: {
	        height: 65,
	        fontSize: 65
	      }
	    },
	
	    // small +
	    '@media screen and (min-width: 48em)': {
	      // MAIN
	      mainContainer: {
	        padding: [40, 20]
	      },
	
	      // EVENTS
	      event: {
	        position: 'relative',
	        display: 'flex',
	        flexDirection: 'column'
	      },
	      eventItem: {
	        zIndex: 2,
	        maxWidth: 620
	      },
	      // Event item even
	      eventItem0: {
	        marginRight: 'auto'
	      },
	      // Event item odd
	      eventItem1: {
	        marginLeft: 'auto'
	      },
	      eventSeparator: {
	        zIndex: 1,
	        position: 'relative',
	        '&:before': {
	          content: '""',
	          display: 'block',
	          position: 'absolute',
	          left: '50%',
	          top: 0,
	          height: 40,
	          borderLeft: '1px solid #e9e9e9'
	        },
	        '&:after': {
	          content: '""',
	          display: 'block',
	          position: 'absolute',
	          borderStyle: 'solid',
	          borderColor: '#e9e9e9',
	          borderWidth: 0
	        },
	        // Left event line
	        '$eventItem0 + &': {
	          '&:after': {
	            left: '18%',
	            width: 300,
	            height: 205,
	            borderWidth: '0 0 1px 1px'
	          }
	        },
	        // Right event line
	        '$eventItem1 + &': {
	          '&:after': {
	            right: '18%',
	            width: 300,
	            height: 205,
	            borderWidth: '0 1px 1px 0'
	          }
	        }
	      },
	
	      // FOOTER
	      footerDrops: {
	        display: 'block'
	      }
	    }
	  };
	};
	
	var EventsPage = function EventsPage(_ref) {
	  var classes = _ref.classes;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Events | Real World React'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.root },
	      _react2.default.createElement(_components.Header, null),
	      _react2.default.createElement(
	        'div',
	        { className: classes.main },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(classes.mainContainer, 'container') },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(classes.mainRow, 'row') },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(classes.mainColumn, 'col-xs-12') },
	              _react2.default.createElement(
	                'div',
	                { className: classes.heading },
	                _react2.default.createElement(_components.Heading, {
	                  className: classes.headingTitle,
	                  titleClassName: classes.headingTitleClassName,
	                  title: 'E V E N T S',
	                  subtitle: 'Talks, Meetups, & Conferences'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: classes.events },
	                _events2.default.map(function (event, index) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: classes.event, key: event.id },
	                    _react2.default.createElement(_components.EventItem, {
	                      className: (0, _classnames2.default)(classes.eventItem, classes['eventItem' + index % 2]),
	                      event: event,
	                      googleAPIKey: _settings2.default.googleAPIKey
	                    }),
	                    index < _events2.default.length - 1 && _react2.default.createElement('div', { className: classes.eventSeparator })
	                  );
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.footer },
	        _react2.default.createElement(
	          'div',
	          { className: classes.footerDrops },
	          _react2.default.createElement(_components.Drops, { bottom: true })
	        ),
	        _react2.default.createElement(_components.Footer, { footerContent: _react2.default.createElement(_containers.SignUp, null), headerContent: _react2.default.createElement(_containers.Contact, null) })
	      )
	    )
	  );
	};
	
	exports.default = (0, _reactJss2.default)(styles)(EventsPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-js-3f43036cc1dcecce0867.js